// "No Known Drug Allergies" (NKDA) is modelled as a regular ADR entry (reaction_type ===
// NKDA_REACTION_TYPE) rather than a boolean flag on the patient record. This keeps NKDA in the
// same identity/audit space as real ADRs (who asserted it, when, and it's naturally superseded
// by adding a real ADR) instead of a separate field that can drift out of sync with the ADR
// list. These helpers centralise how the frontend interprets a patient's `adr` array.

export const NKDA_REACTION_TYPE = 'nkda';

// True if this individual ADR entry is the NKDA assertion marker rather than a real ADR.
export function isNkdaEntry(adr) {
    return !!adr && adr.reaction_type === NKDA_REACTION_TYPE;
}

// The patient's real (non-NKDA) allergy/ADR entries.
export function getRealAdrs(adrList) {
    return (adrList || []).filter((adr) => !isNkdaEntry(adr));
}

// True if the patient's adr list contains an active NKDA assertion.
export function hasNkdaAssertion(adrList) {
    return (adrList || []).some(isNkdaEntry);
}

// Builds a new NKDA assertion entry ready to be posted to `/patient/:uuid/adr`.
export function buildNkdaMarker() {
    return { reaction_type: NKDA_REACTION_TYPE };
}
